var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlbumPrimary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8696 19.8261C22.0222 19.8261 22.9565 18.8917 22.9565 17.7391V3.13043C22.9565 1.97783 22.0222 1.04347 20.8696 1.04347H6.26088C5.10828 1.04347 4.17392 1.97783 4.17392 3.13043",
    stroke: "#006E9C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7391 4.17392H3.13044C1.97785 4.17392 1.04349 5.10828 1.04349 6.26088V20.8696C1.04349 22.0222 1.97785 22.9565 3.13044 22.9565H17.7391C18.8917 22.9565 19.8261 22.0222 19.8261 20.8696V6.26088C19.8261 5.10828 18.8917 4.17392 17.7391 4.17392Z",
    stroke: "#006E9C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78259 11.4783C7.64704 11.4783 8.34781 10.7775 8.34781 9.91304C8.34781 9.0486 7.64704 8.34782 6.78259 8.34782C5.91815 8.34782 5.21738 9.0486 5.21738 9.91304C5.21738 10.7775 5.91815 11.4783 6.78259 11.4783Z",
    stroke: "#006E9C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8261 16.6956L14.6087 11.4783L3.13043 22.9565",
    stroke: "#006E9C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbumPrimary);
export default __webpack_public_path__ + "static/media/albumPrimary.6ca0bc8d262717b5c3efa539b68325ba.svg";
export { ForwardRef as ReactComponent };